import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconApple$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconApple extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'a5051283214a4aae671ae2e87bc197f92a3039b5', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'df9696110b9dfd227b868fa941735d1667637603', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'a615b42daea8cd920c337d87708e80e764801663', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.58 15.193q-.15.436-.318.835a9.8 9.8 0 0 1-.968 1.74q-.763 1.089-1.246 1.506-.746.687-1.603.706-.616 0-1.48-.353-.866-.354-1.593-.353-.764 0-1.638.353-.877.354-1.416.371-.822.036-1.639-.724-.521-.455-1.303-1.56-.84-1.178-1.38-2.739-.578-1.684-.578-3.264 0-1.81.782-3.118.615-1.05 1.64-1.659a4.4 4.4 0 0 1 2.216-.625q.652.002 1.715.399 1.06.399 1.36.4.223 0 1.507-.471 1.212-.436 2.05-.364 2.272.183 3.408 1.795-2.031 1.232-2.01 3.444.018 1.724 1.247 2.864.556.528 1.247.817M14.77 2q.018.18.018.36-.002 1.35-.984 2.519c-.791.925-1.748 1.46-2.786 1.375a3 3 0 0 1-.02-.341c0-.864.376-1.79 1.043-2.546a4 4 0 0 1 1.272-.955q.771-.375 1.457-.412", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-apple", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-apple"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-apple":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconApple$1);
            }
            break;
    } });
}

const CosmosIconApple = CosmosIconApple$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconApple, defineCustomElement };
